import { render, staticRenderFns } from "./SaveUserDialog.vue?vue&type=template&id=2fc19093"
import script from "./SaveUserDialog.vue?vue&type=script&lang=js"
export * from "./SaveUserDialog.vue?vue&type=script&lang=js"
import style0 from "./SaveUserDialog.vue?vue&type=style&index=0&id=2fc19093&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports